import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrOperationManualAddGet, SrOperationService } from '@app/services/sr-operation.service';

@Component({
    selector: 'tt-sr-operation-manual-add',
    templateUrl: './sr-operation-manual-add.component.html',
    styleUrls: ['./sr-operation-manual-add.component.css'],
    standalone: false,
})
export class SrOperationManualAddComponent implements OnInit {
    public page?: SrOperationManualAddGet;
    public operationNumbers: Item[] = [];
    public resources: Item[] = [];
    public saving = false;

    constructor(
        private readonly operation: SrOperationService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        [this.page, this.operationNumbers, this.resources] = await Promise.all([
            this.operation.getManualOperation(), this.operation.getOperationNumbers(), this.operation.getManualResources(),
        ]);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            const response = await this.operation.saveManualOperation(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
